import React, { useState } from 'react'
import AllVendor from './AllVendor';
import PendingApprove from './PendingApprove';
import './Vender.css';
import '../../common/pillTabs.css';
const VendorManagement = () => {

  const [activeComponent, setActiveComponent] = useState(0);

  const handleToggle = (index) => {
    setActiveComponent(index);
  };
  return (
    <div>
    <div className="pill-box" style={{ width: '300px' }}>
      <div
        className="pill-slider"
        style={{
          left: `calc(5px + ${activeComponent} * (100% - 10px) / 2)`,
          width: 'calc((100% - 10px) / 2)',
        }}
      />
      <button className={`pill-btn ${activeComponent === 0 ? 'active' : ''}`} onClick={() => handleToggle(0)}>
        All Vendor
      </button>
      <button className={`pill-btn ${activeComponent === 1 ? 'active' : ''}`} onClick={() => handleToggle(1)}>
        Pending Approve
      </button>
    </div>

    {activeComponent === 0 && <AllVendor />}
    {activeComponent === 1 && <PendingApprove />}
    </div>
  )
}

export default VendorManagement